import React, { useState } from "react";
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Grid,
  Paper,
  Divider
} from "@mui/material";
import CustomTable from "@sistemas.mundo/custom-table";
import useListSolicitudes from "../../../../queries/solicitudes/useListSolicitudes";
import helpers from "@sistemas.mundo/helper-functions";
import InfoIcon from '@mui/icons-material/Info';
import HistoryIcon from '@mui/icons-material/History';
import useDetalleSolicitud from "../../../../queries/ventas/useDetalleSolicitud";
import useHistorialSolicitud from "../../../../queries/ventas/useHistorialSolicitud";

const TablaSolicitudes = () => {

  const [openModalDetalle, setOpenModalDetalle] = useState(false);
  const [openModalHistorial, setOpenModalHistorial] = useState(false);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [historial, setHistorial] = useState([]);

  const esCompraDispositivos = solicitudSeleccionada?.tipo_solicitud?.descripcion_tipo === "Compra de Dispositivos";

  const { data: detalleSolicitud, isLoading: loadingDetalle } = useDetalleSolicitud(
    solicitudSeleccionada?.id_solicitud,
    openModalDetalle && esCompraDispositivos
  );

  const { data: historialData, isLoading: loadingHistorial } = useHistorialSolicitud(
    solicitudSeleccionada?.id_solicitud,
    openModalHistorial
  );

  const historialRespuesta = historialData?.success?.descripcionRespuesta || [];


  const handleOpenDetalle = (row) => {
    setSolicitudSeleccionada(row);
    setOpenModalDetalle(true);
  };

  const handleOpenHistorial = async (row) => {
    setSolicitudSeleccionada(row);
    setOpenModalHistorial(true);
  
    try {
      const response = await fetch(`/api/sucursalVirtual/obtenerHistorialSolicitud?id_solicitud=${row.id_solicitud}`);
      const data = await response.json();
      setHistorial(data.success.descripcionRespuesta);
    } catch (error) {
      console.error("Error al obtener historial:", error);
      setHistorial([]);
    }
  };

  const tableRows = [
    { name: "id_solicitud", type: "", position: "left" },
    { name: "cont_nombres", type: "", position: "left", draw: (row) => row.tipo_solicitud.descripcion_tipo },
    { name: "fecha_creacion_formated", type: "", position: "left" },
    //{ name: "fecha_cierre_formated", type: "", position: "left" },
    { name: "cont_nombres", type: "", position: "left", draw: (row) => row.estado.descripcion_estado },
  
  ];

  const tableHeaders = [
    { name: "N° Solicitud", type: "", position: "left" },
    { name: "Motivo", type: "", position: "left" },
    { name: "Fecha de creación", type: "", position: "left" },
    //{ name: "Fecha de cierre", type: "", position: "left" },
    { name: "Estado", type: "", position: "left" },
    //{ name: "Respuesta", type: "", position: "left" },
  
  ];

  return (
    <>
      <CustomTable queryData={useListSolicitudes} tableRows={tableRows} tableHeaders={tableHeaders} />

      <Dialog open={openModalDetalle} onClose={() => setOpenModalDetalle(false)} fullWidth>
  <DialogTitle sx={{ color: "#00657D", fontWeight: "bold" }}>Ver Detalle</DialogTitle>
  <DialogContent>
    {solicitudSeleccionada && esCompraDispositivos ? (
      <>
        <p><strong>ID:</strong> {solicitudSeleccionada.id_solicitud}</p>
        <p><strong>Motivo:</strong> {solicitudSeleccionada.tipo_solicitud.descripcion_tipo}</p>

        <Grid container spacing={2}>
  {detalleSolicitud?.map((detalle, idx) => (
    <Grid item xs={12} key={idx}>
      <Paper elevation={3} sx={{ padding: 2, borderRadius: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
          Artículo: {detalle.nombre_articulo}
        </Typography>
        <Divider sx={{ marginBottom: 1 }} />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="body2"><strong>Cantidad:</strong> {detalle.deso_cantidad_item}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2"><strong>Monto:</strong> {helpers.currencys.formatterPeso.format(detalle.desp_monto_item)}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  ))}
</Grid>
      </>
    ) : (
      <p>Esta solicitud no tiene detalles disponibles.</p>
    )}
  </DialogContent>
</Dialog>
<Dialog open={openModalHistorial} onClose={() => setOpenModalHistorial(false)} fullWidth maxWidth="md">
  <DialogTitle sx={{ color: "#00657D", fontWeight: "bold" }}>Historial de Cambios</DialogTitle>
  <DialogContent>
  {loadingHistorial ? (
    <CircularProgress />
  ) : historialRespuesta.length > 0 ? (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell><strong>Estado</strong></TableCell>
          <TableCell><strong>Descripción</strong></TableCell>
          <TableCell><strong>Fecha</strong></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {historialRespuesta.map((item) => (
          <TableRow key={item.id}>
            <TableCell>{item.estado?.descripcion_estado || "-"}</TableCell>
            <TableCell>{item.descripcion}</TableCell>
            <TableCell>
              {item.created_at
                ? new Date(item.created_at).toLocaleString("es-CL")
                : "-"}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  ) : (
    <p>No hay historial disponible para esta solicitud.</p>
  )}
</DialogContent>
</Dialog>

    </>
  );
};

export default TablaSolicitudes;
